import { Mesh } from "three";
import { Assets } from "../Assets";
import { LevelObject } from "../LevelObject";
import { Obstacle } from "../components/Obstacle";
import { dirForward, dirOpposite, dirRotation } from "../Direction";
import { Benchtop } from "../components/Benchtop";
import { Updater } from "../components/Updater";
export class ServingSpot extends Updater(Benchtop(Obstacle(LevelObject))) {
    constructor(levelMap, position, dir) {
        super(levelMap, Assets.objects.ServingSpot.clone(), position);
        this.model.quaternion.copy(dirRotation(dir));
        this.shelfHeight = 0.74;
        this.deliverDirection = dirForward(dirOpposite(dir));
        for (const child of this.model.children) {
            if (child instanceof Mesh && child.material.name === 'Conveyor') {
                this.conveyor = child;
            }
        }
    }
    static get type() {
        return 'food_conveyor';
    }
    startStep(step) {
        super.startStep(step);
        const deliverable = this.levelMap.getLooseObject(this.tilePos);
        if (deliverable) {
            this.levelMap.removeLooseObject(deliverable);
            this.deliverable = deliverable;
        }
    }
    endStep(step) {
        if (this.deliverable) {
            this.levelMap.world.remove(this.deliverable);
            this.levelMap.world.onServed(this.deliverable);
            this.deliverable = undefined;
        }
    }
    update(step, duration) {
        super.update(step, duration);
        if (this.deliverable) {
            this.deliverable.position.x += this.deliverDirection.x * 0.002 * duration;
            this.deliverable.position.z += this.deliverDirection.y * 0.002 * duration;
            const uvAttribute = this.conveyor.geometry.attributes.uv;
            for (var i = 0; i < uvAttribute.count; i++) {
                var u = uvAttribute.getX(i);
                var v = uvAttribute.getY(i);
                uvAttribute.setXY(i, u, v + 0.005 * duration);
            }
            uvAttribute.needsUpdate = true;
        }
    }
}
